import { recalculatePageMargin } from './helpers';

jQuery(function ($) {
  $('.subnav--subsite .subnav-item').on('mouseenter', function () {
    $(this).addClass('mouseover');

    const toggle = $('.dropdown-toggle', this)[0];
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
      const dd = bootstrap.Dropdown.getOrCreateInstance(toggle);
      dd.show();

      setTimeout(() => {
        toggle.blur();
      }, 0);
    }
  });

  $('.subnav--subsite .subnav-item').on('mouseleave', function () {
    $(this).removeClass('mouseover');

    const toggle = $('.dropdown-toggle', this)[0];
    if (toggle && toggle.getAttribute('aria-expanded') !== 'false') {
      const dd = bootstrap.Dropdown.getOrCreateInstance(toggle);
      dd.hide();

      setTimeout(() => {
        toggle.blur();
      }, 0);

      // Collapse all for next menu open
      $(toggle).parent().find('.subnav-item__toggle').attr('aria-expanded', 'false');
      $(toggle).parent().find('.nested-nav.show').removeClass('show');
    }

    // Blur any focused element within the subnav-item
    $(this).find(':focus').blur();
  });

  // Prevent nested collapse from closing dropdown
  $('.nested-nav__item').on('click', '.subnav-item__toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const toggle = $(this);
    const children = $(`[data-parentid="${toggle.data('itemid')}"]`);
    if (toggle.attr('aria-expanded') === 'false') {
      toggle.attr('aria-expanded', 'true');
      children.addClass('show');
    } else {
      toggle.attr('aria-expanded', 'false');
      children.removeClass('show');
    }
  });

  $('.subnav--subsite .subnav__desktop-items > .nav-item > .subnav-item').each(function () {
    // Properly set the reference to be the parent. Data attribute wasn't working.
    const toggleEl = $('.dropdown-toggle', this)[0];
    if (toggleEl) {
      new bootstrap.Dropdown(toggleEl, { reference: this });
    }
  });

  // Keep mobile menu height in sync with top nav height
  const bodyRo = new ResizeObserver(() => {
    const $subsiteNav = $('.subnav--subsite .subnav__navbar');
    const $pageBotton = $('#page-bottom');
    if ($subsiteNav.length && $pageBotton.length) {
      recalculatePageMargin();

      const subsiteNavBottom = $subsiteNav[0].getBoundingClientRect().bottom;
      const pageBottom = $pageBotton[0].getBoundingClientRect().top;

      // Use invisible element at bottom of page to avoid 'vh' on mobile.
      $('.subnav--subsite').css('max-height', `${pageBottom - (subsiteNavBottom - 51)}px`);

      // Cap height of desktop dropdowns
      $('.subnav--subsite .dropdown-menu').css('max-height', `calc(100vh - ${subsiteNavBottom}px)`);
    }
  });

  bodyRo.observe($('body')[0]);

  // Fontawesome icons loading after initial page load can cause a resize by
  // way of wrapping.
  const subnav = $('.subnav--subsite');
  if (subnav.length) {
    const subnavRo = new ResizeObserver(recalculatePageMargin);
    subnavRo.observe(subnav[0]);
  }
});
